import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const ImageWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const DList = styled.dl(() =>
  mq({
    marginBottom: defaultTheme.spacing.xxl,
    '& > dt': {
      fontSize: defaultTheme.font.size.m,
      fontWeight: 'bold',
      marginBottom: defaultTheme.spacing.l,
    },
    '& > dd': {
      fontSize: defaultTheme.font.size.s,
      lineHeight: defaultTheme.font.height.l,
      marginBottom: defaultTheme.spacing.l,
      '& > a': {
        textDecorationLine: 'underline',
        ...hoverOpacity,
      },
    },
  }),
);

export const IconImage = styled.img(() =>
  mq({
    width: '14px',
    height: '14px',
  }),
);

export const ExpectationList = styled.ul(() =>
  mq({
    marginTop: defaultTheme.spacing.l,
    li: {
      display: 'flex',
      alignItems: 'center',
      '& > img': {
        marginRight: defaultTheme.spacing.xs,
      },
    },
  }),
);

export const SmallText = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
  }),
);

export const RecentResultWrapper = styled.div(() =>
  mq({
    '& > h2': {
      borderTop: '1px solid #E6E6E6',
      paddingTop: defaultTheme.spacing.xxl,
    },
  }),
);
